module.exports = __webpack_public_path__ + "img/Chenye.6e907a8d.jpg";